export default __webpack_public_path__ + "static/media/man-going-up.c9489c09.svg";